import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import HelperFriend from '../../../Prototype/Level/HelperFriend';
import SpriteComponent from '../../../Component/Render/Sprite';
import { delay } from '../../../Utility/Task/TaskQueue';

export class HelperFriendLoop extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: { duration: number }
    ): IterableIterator<number> {
        const baseSprite: GameObject = gameObject.find(HelperFriend.BASE);

        const lights: GameObject[] = baseSprite.children.filter(
            (child: GameObject) => child.name.includes('light')
        );

        let odd: boolean = false;
        while (true) {
            lights.forEach((light: GameObject, index: number) => {
                const spriteComponent: SpriteComponent = light.getComponent(
                    SpriteComponent
                );

                if (index % 2 === Number(odd)) {
                    spriteComponent.texture = 'light_small_2';
                } else {
                    spriteComponent.texture = 'light_small_1';
                }
            });
            odd = !odd;
            yield* delay(350);
        }
    }
}
